import React from 'react'
import { TextField } from '@material-ui/core'
import { Autocomplete } from '@mui/material';


const SelectMultipleForm = (props: any) => {
 
    const setValue = (values: any) => {
	    
	    //TEXT FORMAT FOR VALIDATION RULES (ARRAY => STRING)
	    var newValues: any = []
	    values.forEach((value: any)=>{
		    newValues.push(value.value)
		})
		props.formikProps.values[props.field.name] = newValues.join(", ")
		window.FormSettings[props.form_name][props.field.name]['value'] = newValues
		
    }
 
    //EXTRACT ID
    const formDrupalValues = () => {
	    
	    if(window.FormSettings[props.form_name][props.field.name]['value']){
		    
		    //IDS OPTIONS
		    //var ids: any = []
		    var val : any = []
		    window.FormSettings[props.form_name][props.field.name]['value'].forEach((value: any)=>{
			    val.push({
				    "value" : value,
				    "label" : props.element.base_options[value]
			    })  
			})
			
			
			setValue(val)
		    
		    return val
	    }
	    
    }
    
    const getOptions = () => {
	    
	    var options: any = []
	    
	    props.element.options.map((values:any)=> {
		    if(values.value !== "_none"){
			    options.push({
				    "value" : values.value,
				    "label" : values.label
			    })   
		    }
        })
        
	    return options
    }

    const inputValue = formDrupalValues()
 
    return (
		<Autocomplete
		  disablePortal
		  noOptionsText={' '}
		  id={props.element.id ? "select-" + props.element.id.toString() : ""}
		  options={ getOptions() }
		  sx={{  }}
		  multiple
		  className='form-control form-control-solid form-control-lg'
		  defaultValue={inputValue}
		  isOptionEqualToValue={(option:any, value) => {
			  //console.log("isOptionEqualToValue", option, value);
		      return parseInt(option.value) === parseInt(value.value)
		  }}
		  
		  renderInput={(params) => <TextField {...params} label="" />}
		  onChange={(event, newValue) => {
		      setValue(newValue);
		  }}
		/>
    )
 
}


export default SelectMultipleForm
